/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'
import { JBP_DIRECT_REPORT_EXECUTION_FRAGMENT } from '../fragments/JBPDirectReportExecutionFragment'

export const GET_JBP_EXECUTION_BY_DIRECT_REPORT = gql`
  query GetJBPExecutionByDirectReport($input: JBPReportInput!) {
    jbpExecutionByDirectReport(input: $input) {
      results {
        ...JBPExecutionByDirectReport
      }
      count
    }
  }
  ${JBP_DIRECT_REPORT_EXECUTION_FRAGMENT}
`
